import { FinalVisualizationBuilder } from '../../../app/configurator/VisualizationBuilder';
import { OrderItemData } from '../../../app/data/model';
import ConfigurationImage from '../../../app/shared/components/ConfigurationImage';
import { Panel } from '../../../app/shared/components/Panel/Panel';
import { CartItemDetails } from '../../cart/CartItem/CartItemDetails/CartItemDetails';
import { OrderItemTranslation } from '../../localization/SiteTranslation';
import css from './OrderItem.css';

export const OrderItem = (props: { item: OrderItemData; translation: OrderItemTranslation }) => {
  let { item, translation } = props;
  const imgWidth = 120;
  const imgHeight = 120;

  return (
    <Panel
      headerComponent={
        <div className={css.orderItemPanelHeader}>
          <strong className={css.orderItemPanelHeaderBrand}>{item.brandName}</strong> {item.shortName}
        </div>
      }
      bodyClassName={css.orderItemPanelContent}
    >
      <ConfigurationImage
        configurationCodeOrigin={item.configurationCodeOrigin}
        imageFallbackClassName={css.imageFallback}
        className={css.orderItemImage}
        src={FinalVisualizationBuilder.buildUrl(item.configurationCode, undefined, undefined, imgWidth, imgHeight)}
        width={imgWidth}
        height={imgHeight}
        sharpeningFactor={1.5}
        scalingMode="fit"
      />
      <div className={css.orderItemDetails}>
        <CartItemDetails
          code={item.configurationCode}
          listPrice={item.totalPrice}
          salePrice={item.price}
          quantity={item.quantity}
          className={css.orderItemPropertiesContainer}
          propertyClassNames={{
            valueClassName: css.orderItemPropertyValue,
          }}
          translation={translation.cartItemDetails}
        />
      </div>
    </Panel>
  );
};
